import { resendTwoFactorAuthCode } from "@/api/twofactorauth";
import useSnackbar from "@/hooks/useSnackbar";
import { useState } from "react";

export default function useResendTwoFactor() {
  const snackbar = useSnackbar();
  const [isSending, setIsSending] = useState(false);
  const [isError, setIsError] = useState(false);
  const handleResend = async () => {
    setIsSending(true);
    try {
      await resendTwoFactorAuthCode();
      snackbar.setFeedback({
        open: true,
        type: "default",
        message: "The code has been resent.",
        placement: "top",
        duration: 5000,
      });
    } catch {
      setIsError(true);
    }
    setIsSending(false);
  };
  return { isSending, isError, handleResend };
}
